import { render, staticRenderFns } from "./SoftwareStatus.vue?vue&type=template&id=4f232346&scoped=true&"
import script from "./SoftwareStatus.vue?vue&type=script&lang=js&"
export * from "./SoftwareStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f232346",
  null
  
)

export default component.exports